/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accountLoginCreate } from '../fn/auth/account-login-create';
import { accountLoginCreate$FormData } from '../fn/auth/account-login-create-form-data';
import { AccountLoginCreate$FormData$Params } from '../fn/auth/account-login-create-form-data';
import { AccountLoginCreate$Params } from '../fn/auth/account-login-create';
import { accountLoginCreate$XWwwFormUrlencoded } from '../fn/auth/account-login-create-x-www-form-urlencoded';
import { AccountLoginCreate$XWwwFormUrlencoded$Params } from '../fn/auth/account-login-create-x-www-form-urlencoded';
import { accountMeRestorePasswordConfirmCreate } from '../fn/auth/account-me-restore-password-confirm-create';
import { accountMeRestorePasswordConfirmCreate$FormData } from '../fn/auth/account-me-restore-password-confirm-create-form-data';
import { AccountMeRestorePasswordConfirmCreate$FormData$Params } from '../fn/auth/account-me-restore-password-confirm-create-form-data';
import { AccountMeRestorePasswordConfirmCreate$Params } from '../fn/auth/account-me-restore-password-confirm-create';
import { accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded } from '../fn/auth/account-me-restore-password-confirm-create-x-www-form-urlencoded';
import { AccountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded$Params } from '../fn/auth/account-me-restore-password-confirm-create-x-www-form-urlencoded';
import { accountMeRestorePasswordCreate } from '../fn/auth/account-me-restore-password-create';
import { accountMeRestorePasswordCreate$FormData } from '../fn/auth/account-me-restore-password-create-form-data';
import { AccountMeRestorePasswordCreate$FormData$Params } from '../fn/auth/account-me-restore-password-create-form-data';
import { AccountMeRestorePasswordCreate$Params } from '../fn/auth/account-me-restore-password-create';
import { accountMeRestorePasswordCreate$XWwwFormUrlencoded } from '../fn/auth/account-me-restore-password-create-x-www-form-urlencoded';
import { AccountMeRestorePasswordCreate$XWwwFormUrlencoded$Params } from '../fn/auth/account-me-restore-password-create-x-www-form-urlencoded';
import { accountMeVerifyConfirmCreate } from '../fn/auth/account-me-verify-confirm-create';
import { accountMeVerifyConfirmCreate$FormData } from '../fn/auth/account-me-verify-confirm-create-form-data';
import { AccountMeVerifyConfirmCreate$FormData$Params } from '../fn/auth/account-me-verify-confirm-create-form-data';
import { AccountMeVerifyConfirmCreate$Params } from '../fn/auth/account-me-verify-confirm-create';
import { accountMeVerifyConfirmCreate$XWwwFormUrlencoded } from '../fn/auth/account-me-verify-confirm-create-x-www-form-urlencoded';
import { AccountMeVerifyConfirmCreate$XWwwFormUrlencoded$Params } from '../fn/auth/account-me-verify-confirm-create-x-www-form-urlencoded';
import { accountMeVerifyCreate } from '../fn/auth/account-me-verify-create';
import { AccountMeVerifyCreate$Params } from '../fn/auth/account-me-verify-create';
import { accountRegisterCreate } from '../fn/auth/account-register-create';
import { accountRegisterCreate$FormData } from '../fn/auth/account-register-create-form-data';
import { AccountRegisterCreate$FormData$Params } from '../fn/auth/account-register-create-form-data';
import { AccountRegisterCreate$Params } from '../fn/auth/account-register-create';
import { accountRegisterCreate$XWwwFormUrlencoded } from '../fn/auth/account-register-create-x-www-form-urlencoded';
import { AccountRegisterCreate$XWwwFormUrlencoded$Params } from '../fn/auth/account-register-create-x-www-form-urlencoded';
import { BackendLoginDto } from '../models/backend-login-dto';
import { BackendRestorePasswordDto } from '../models/backend-restore-password-dto';
import { BackendRestorePasswordConfirmDto } from '../models/backend-restore-password-confirm-dto';
import { BackendUserRegisterDto } from '../models/backend-user-register-dto';
import { BackendVerifyConfirmDto } from '../models/backend-verify-confirm-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accountLoginCreate()` */
  static readonly AccountLoginCreatePath = '/api/account/login/';

  /**
   * Обработка POST-запроса для входа пользователя.
   *
   * Проверяет данные для входа на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и проверенные данные.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountLoginCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountLoginCreate$Response(
    params: AccountLoginCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLoginDto>> {
    return accountLoginCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обработка POST-запроса для входа пользователя.
   *
   * Проверяет данные для входа на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и проверенные данные.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountLoginCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountLoginCreate(params: AccountLoginCreate$Params, context?: HttpContext): Observable<BackendLoginDto> {
    return this.accountLoginCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLoginDto>): BackendLoginDto => r.body),
    );
  }

  /**
   * Обработка POST-запроса для входа пользователя.
   *
   * Проверяет данные для входа на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и проверенные данные.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountLoginCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountLoginCreate$XWwwFormUrlencoded$Response(
    params: AccountLoginCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLoginDto>> {
    return accountLoginCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обработка POST-запроса для входа пользователя.
   *
   * Проверяет данные для входа на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и проверенные данные.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountLoginCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountLoginCreate$XWwwFormUrlencoded(
    params: AccountLoginCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLoginDto> {
    return this.accountLoginCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLoginDto>): BackendLoginDto => r.body),
    );
  }

  /**
   * Обработка POST-запроса для входа пользователя.
   *
   * Проверяет данные для входа на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и проверенные данные.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountLoginCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountLoginCreate$FormData$Response(
    params: AccountLoginCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLoginDto>> {
    return accountLoginCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обработка POST-запроса для входа пользователя.
   *
   * Проверяет данные для входа на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и проверенные данные.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountLoginCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountLoginCreate$FormData(
    params: AccountLoginCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLoginDto> {
    return this.accountLoginCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLoginDto>): BackendLoginDto => r.body),
    );
  }

  /** Path part for operation `accountMeRestorePasswordCreate()` */
  static readonly AccountMeRestorePasswordCreatePath = '/api/account/me/restore_password/';

  /**
   * Представление для восстановления пароля пользователя.
   * Принимает данные сериализатора с адресом электронной почты пользователя.
   * Если данные валидны и пользователь с такой почтой существует,
   * отправляет письмо для восстановления пароля.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRestorePasswordCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeRestorePasswordCreate$Response(
    params: AccountMeRestorePasswordCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRestorePasswordDto>> {
    return accountMeRestorePasswordCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для восстановления пароля пользователя.
   * Принимает данные сериализатора с адресом электронной почты пользователя.
   * Если данные валидны и пользователь с такой почтой существует,
   * отправляет письмо для восстановления пароля.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRestorePasswordCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeRestorePasswordCreate(
    params: AccountMeRestorePasswordCreate$Params,
    context?: HttpContext,
  ): Observable<BackendRestorePasswordDto> {
    return this.accountMeRestorePasswordCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRestorePasswordDto>): BackendRestorePasswordDto => r.body),
    );
  }

  /**
   * Представление для восстановления пароля пользователя.
   * Принимает данные сериализатора с адресом электронной почты пользователя.
   * Если данные валидны и пользователь с такой почтой существует,
   * отправляет письмо для восстановления пароля.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRestorePasswordCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeRestorePasswordCreate$XWwwFormUrlencoded$Response(
    params: AccountMeRestorePasswordCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRestorePasswordDto>> {
    return accountMeRestorePasswordCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для восстановления пароля пользователя.
   * Принимает данные сериализатора с адресом электронной почты пользователя.
   * Если данные валидны и пользователь с такой почтой существует,
   * отправляет письмо для восстановления пароля.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRestorePasswordCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeRestorePasswordCreate$XWwwFormUrlencoded(
    params: AccountMeRestorePasswordCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendRestorePasswordDto> {
    return this.accountMeRestorePasswordCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRestorePasswordDto>): BackendRestorePasswordDto => r.body),
    );
  }

  /**
   * Представление для восстановления пароля пользователя.
   * Принимает данные сериализатора с адресом электронной почты пользователя.
   * Если данные валидны и пользователь с такой почтой существует,
   * отправляет письмо для восстановления пароля.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRestorePasswordCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeRestorePasswordCreate$FormData$Response(
    params: AccountMeRestorePasswordCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRestorePasswordDto>> {
    return accountMeRestorePasswordCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для восстановления пароля пользователя.
   * Принимает данные сериализатора с адресом электронной почты пользователя.
   * Если данные валидны и пользователь с такой почтой существует,
   * отправляет письмо для восстановления пароля.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRestorePasswordCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeRestorePasswordCreate$FormData(
    params: AccountMeRestorePasswordCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendRestorePasswordDto> {
    return this.accountMeRestorePasswordCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRestorePasswordDto>): BackendRestorePasswordDto => r.body),
    );
  }

  /** Path part for operation `accountMeRestorePasswordConfirmCreate()` */
  static readonly AccountMeRestorePasswordConfirmCreatePath = '/api/account/me/restore_password/confirm/';

  /**
   * Представление для подтверждения восстановления пароля пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения и новым паролем.
   * Если данные валидны, обновляет пароль пользователя, отправляет уведомление об изменении пароля.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRestorePasswordConfirmCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeRestorePasswordConfirmCreate$Response(
    params: AccountMeRestorePasswordConfirmCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRestorePasswordConfirmDto>> {
    return accountMeRestorePasswordConfirmCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения восстановления пароля пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения и новым паролем.
   * Если данные валидны, обновляет пароль пользователя, отправляет уведомление об изменении пароля.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRestorePasswordConfirmCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeRestorePasswordConfirmCreate(
    params: AccountMeRestorePasswordConfirmCreate$Params,
    context?: HttpContext,
  ): Observable<BackendRestorePasswordConfirmDto> {
    return this.accountMeRestorePasswordConfirmCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRestorePasswordConfirmDto>): BackendRestorePasswordConfirmDto => r.body),
    );
  }

  /**
   * Представление для подтверждения восстановления пароля пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения и новым паролем.
   * Если данные валидны, обновляет пароль пользователя, отправляет уведомление об изменении пароля.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded$Response(
    params: AccountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRestorePasswordConfirmDto>> {
    return accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения восстановления пароля пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения и новым паролем.
   * Если данные валидны, обновляет пароль пользователя, отправляет уведомление об изменении пароля.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded(
    params: AccountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendRestorePasswordConfirmDto> {
    return this.accountMeRestorePasswordConfirmCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRestorePasswordConfirmDto>): BackendRestorePasswordConfirmDto => r.body),
    );
  }

  /**
   * Представление для подтверждения восстановления пароля пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения и новым паролем.
   * Если данные валидны, обновляет пароль пользователя, отправляет уведомление об изменении пароля.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRestorePasswordConfirmCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeRestorePasswordConfirmCreate$FormData$Response(
    params: AccountMeRestorePasswordConfirmCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendRestorePasswordConfirmDto>> {
    return accountMeRestorePasswordConfirmCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения восстановления пароля пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения и новым паролем.
   * Если данные валидны, обновляет пароль пользователя, отправляет уведомление об изменении пароля.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRestorePasswordConfirmCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeRestorePasswordConfirmCreate$FormData(
    params: AccountMeRestorePasswordConfirmCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendRestorePasswordConfirmDto> {
    return this.accountMeRestorePasswordConfirmCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendRestorePasswordConfirmDto>): BackendRestorePasswordConfirmDto => r.body),
    );
  }

  /** Path part for operation `accountMeVerifyCreate()` */
  static readonly AccountMeVerifyCreatePath = '/api/account/me/verify/';

  /**
   * Представление для подтверждения учетной записи пользователя.
   * Если пользователь не верифицирован, отправляется письмо для подтверждения почты.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   * Если аккаунт уже верифицирован, возвращает ошибку с соответствующим сообщением.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeVerifyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeVerifyCreate$Response(
    params?: AccountMeVerifyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accountMeVerifyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения учетной записи пользователя.
   * Если пользователь не верифицирован, отправляется письмо для подтверждения почты.
   * Возвращает успешный статус код 200, если письмо было отправлено успешно.
   * Если аккаунт уже верифицирован, возвращает ошибку с соответствующим сообщением.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeVerifyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeVerifyCreate(params?: AccountMeVerifyCreate$Params, context?: HttpContext): Observable<void> {
    return this.accountMeVerifyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `accountMeVerifyConfirmCreate()` */
  static readonly AccountMeVerifyConfirmCreatePath = '/api/account/me/verify/confirm/';

  /**
   * Представление для подтверждения учетной записи пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения.
   * Если данные валидны, сохраняет информацию о подтверждении, отправляет письмо с приветствием.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeVerifyConfirmCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeVerifyConfirmCreate$Response(
    params: AccountMeVerifyConfirmCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVerifyConfirmDto>> {
    return accountMeVerifyConfirmCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения учетной записи пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения.
   * Если данные валидны, сохраняет информацию о подтверждении, отправляет письмо с приветствием.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeVerifyConfirmCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeVerifyConfirmCreate(
    params: AccountMeVerifyConfirmCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVerifyConfirmDto> {
    return this.accountMeVerifyConfirmCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVerifyConfirmDto>): BackendVerifyConfirmDto => r.body),
    );
  }

  /**
   * Представление для подтверждения учетной записи пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения.
   * Если данные валидны, сохраняет информацию о подтверждении, отправляет письмо с приветствием.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeVerifyConfirmCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeVerifyConfirmCreate$XWwwFormUrlencoded$Response(
    params: AccountMeVerifyConfirmCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVerifyConfirmDto>> {
    return accountMeVerifyConfirmCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения учетной записи пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения.
   * Если данные валидны, сохраняет информацию о подтверждении, отправляет письмо с приветствием.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeVerifyConfirmCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeVerifyConfirmCreate$XWwwFormUrlencoded(
    params: AccountMeVerifyConfirmCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVerifyConfirmDto> {
    return this.accountMeVerifyConfirmCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVerifyConfirmDto>): BackendVerifyConfirmDto => r.body),
    );
  }

  /**
   * Представление для подтверждения учетной записи пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения.
   * Если данные валидны, сохраняет информацию о подтверждении, отправляет письмо с приветствием.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeVerifyConfirmCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeVerifyConfirmCreate$FormData$Response(
    params: AccountMeVerifyConfirmCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVerifyConfirmDto>> {
    return accountMeVerifyConfirmCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для подтверждения учетной записи пользователя с помощью токена подтверждения.
   * Принимает данные сериализатора с токеном подтверждения.
   * Если данные валидны, сохраняет информацию о подтверждении, отправляет письмо с приветствием.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeVerifyConfirmCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeVerifyConfirmCreate$FormData(
    params: AccountMeVerifyConfirmCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVerifyConfirmDto> {
    return this.accountMeVerifyConfirmCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVerifyConfirmDto>): BackendVerifyConfirmDto => r.body),
    );
  }

  /** Path part for operation `accountRegisterCreate()` */
  static readonly AccountRegisterCreatePath = '/api/account/register/';

  /**
   * Обработка POST-запроса для регистрации нового пользователя.
   *
   * Создает нового пользователя на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и сохраняет данные пользователя.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRegisterCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRegisterCreate$Response(
    params: AccountRegisterCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRegisterDto>> {
    return accountRegisterCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обработка POST-запроса для регистрации нового пользователя.
   *
   * Создает нового пользователя на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и сохраняет данные пользователя.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRegisterCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRegisterCreate(
    params: AccountRegisterCreate$Params,
    context?: HttpContext,
  ): Observable<BackendUserRegisterDto> {
    return this.accountRegisterCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRegisterDto>): BackendUserRegisterDto => r.body),
    );
  }

  /**
   * Обработка POST-запроса для регистрации нового пользователя.
   *
   * Создает нового пользователя на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и сохраняет данные пользователя.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRegisterCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountRegisterCreate$XWwwFormUrlencoded$Response(
    params: AccountRegisterCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRegisterDto>> {
    return accountRegisterCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обработка POST-запроса для регистрации нового пользователя.
   *
   * Создает нового пользователя на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и сохраняет данные пользователя.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRegisterCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountRegisterCreate$XWwwFormUrlencoded(
    params: AccountRegisterCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendUserRegisterDto> {
    return this.accountRegisterCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRegisterDto>): BackendUserRegisterDto => r.body),
    );
  }

  /**
   * Обработка POST-запроса для регистрации нового пользователя.
   *
   * Создает нового пользователя на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и сохраняет данные пользователя.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRegisterCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountRegisterCreate$FormData$Response(
    params: AccountRegisterCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRegisterDto>> {
    return accountRegisterCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обработка POST-запроса для регистрации нового пользователя.
   *
   * Создает нового пользователя на основе данных из запроса.
   * Если данные валидны, возвращает статус HTTP 200 OK и сохраняет данные пользователя.
   * Если данные невалидны, возвращает статус HTTP 400 BAD REQUEST и ошибки валидации.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRegisterCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountRegisterCreate$FormData(
    params: AccountRegisterCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendUserRegisterDto> {
    return this.accountRegisterCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRegisterDto>): BackendUserRegisterDto => r.body),
    );
  }
}
